{
	"selectPeriod": "Sélectionner une période",
	"periodSelected": "Période sélectionnée",
	"reset": "Réinitialiser",
	"apply": "Appliquer",
	"ariaLabels": {
		"periodSelection": "Sélectionner une période",
		"periodSelectionOptions": "Options de sélection de période",
		"periodSelectionDialog": "Sélection de période",
		"dateRangeSelection": "Sélection de plage de dates",
		"dateRangeSelectionActions": "Actions de sélection de plage de dates",
		"resetDateRange": "Réinitialiser la sélection de plage de dates",
		"applyDateRange": "Appliquer la sélection de plage de dates"
	}
}
